<template>
  <div
    :style="rowMode ? 'display: flex; flex-flow: row nowrap; justify-content: space-between; width: 100%; gap: 10px; background-color: #EFF3F6;' : ''">
    <div
      :style="rowMode ? 'width: 50%' : ''"
      :class="rowMode ? 'is-border' : ''"
      class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
      <div
        class="column is-narrow is-flex is-padding-small"
        :class="program.is_valid ? 'has-background-success' : 'has-background-white--darken1'"
        :data-tooltip="program.is_valid ? 'Fiche programme complète' : 'Fiche programme incomplète'">
        <span
          class="icon is-self-centered"
          :class="program.is_valid ? 'has-text-white' : 'has-text-danger'">
          <i
            class="fas"
            :class="program.is_valid ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
        </span>
      </div>
      <div class="column is-self-centered is-padding-left">
        <div
          :class="rowMode ? 'is-5' : 'is-4'"
          class="title ">
          Informations Programme
        </div>
        <div
          v-if="!program.is_valid"
          class="subtitle is-6 has-text-danger">
          Informations manquantes
        </div>
      </div>
      <div
        v-if="displayButton"
        class="actionsOnRow actionsOnRow--vertical"
        :style="ForPreResa ? 'border-left: 0px' : ''">
        <div
          class="is-minH100">
          <!-- seulement à ajouter quand il y a un seul élément-->
          <router-link
            class="tooltip is-tooltip-left"
            data-tooltip="Modifier la fiche programme"
            tag="button"
            :to="{name: 'ProgramEdit', params: {id: program.pk}, query: { check: 1 }}">
            <span
              v-if="ForPreResa"
              class="icon is-size-5"><i class="fas fa-arrow-right"></i></span>
            <span
              v-else
              class="icon"><i class="fal fa-file-edit"></i></span>
          </router-link>
        </div>
      </div>
    </div>
    <div
      :style="rowMode ? 'width: 50%' : ''"
      :class="rowMode ? 'is-border' : ''"
      class="columns is-gapless is-marginless has-background-white is-minH64p is-border-top">
      <div
        class="column is-narrow is-flex is-padding-small"
        :class="lot.is_valid ? 'has-background-success' : 'has-background-white--darken1'"
        :data-tooltip="lot.is_valid ? 'Fiche lot complète' : 'Fiche lot incomplète'">
        <span
          class="icon is-self-centered"
          :class="lot.is_valid ? 'has-text-white' : 'has-text-danger'">
          <i
            class="fas"
            :class="lot.is_valid ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
        </span>
      </div>
      <div class="column is-self-centered is-padding-left">
        <div
          v-if="lot.nature === 'parking'"
          :class="rowMode ? 'is-5' : 'is-4'"
          class="title">
          Informations Stationnement
        </div>
        <div
          v-else
          :class="rowMode ? 'is-5' : 'is-4'"
          class="title">
          Informations Lot
        </div>
        <div
          v-if="!lot.is_valid"
          class="subtitle is-6 has-text-danger">
          Informations manquantes
        </div>
      </div>
      <div
        v-if="displayButton"
        class="actionsOnRow actionsOnRow--vertical"
        :style="ForPreResa ? 'border-left: 0px' : ''">
        <div class="is-minH100">
          <!-- seulement à ajouter quand il y a un seul élément-->
          <router-link
            v-if="lot.nature === 'parking'"
            class="tooltip is-tooltip-left"
            data-tooltip="Modifier la fiche parking"
            tag="button"
            :to="{name: 'LotEdit', params: {id: lot.pk}, query: { check: 1 }}">
            <span
              v-if="ForPreResa"
              class="icon"><i class="fas fa-arrow-right"></i></span>
            <span
              v-else
              class="icon"><i class="fal fa-file-edit"></i></span>
          </router-link>
          <router-link
            v-else
            class="tooltip is-tooltip-left"
            data-tooltip="Modifier la fiche lot"
            tag="button"
            :to="{name: 'LotEdit', params: {id: lot.pk}, query: { check: 1 }}">
            <span
              v-if="ForPreResa"
              class="icon"><i class="fas fa-arrow-right"></i></span>
            <span
              v-else
              class="icon"><i class="fal fa-file-edit"></i></span>
          </router-link>
        </div>
      </div>
    </div>
    <div
      class="columns has-background-white is-gapless is-border-top has-text-black-ter is-padding"
      v-if="showSpecifications">
      <div class="column is-padding-right-xsmall">
        <div class="is-margin-bottom-small">
          <span class="is-uppercase is-size-6 has-text-weight-medium">Caractéristiques du lot</span>
        </div>
        <div class="is-size-6">
          <div v-if="(lot && lot.nature) || (lot && lot.lot_type)">
            <b>Nature et type :</b><span v-if="lot && lot.nature"> {{ lot.nature | natureLabel }}</span>
            <!-- <span v-else-if="lot && lot.nature && lot && lot.lot_type">-</span> -->
            &nbsp;
            <span v-if="lot && lot.lot_type">{{ lot.lot_type | lotTypeLabel }}</span>
          </div>
          <div v-if="lot && lot.lot_subtype">
            <b>Caractéristiques : </b>{{ lot.lot_subtype | lotSubtypesLabel }}
          </div>
          <div v-if="lot && lot.surface">
            <b>Surface : </b>{{ lot.surface | prettyPrice }} m²
          </div>
          <div v-if="lot && lot.building">
            <b>Bâtiment : </b>{{ lot.building.name }}
          </div>
          <div v-if="lot && lot.floor">
            <b>Etage :</b> {{ lot.floor | floorLabel }}
          </div>
          <div v-if="lot && lot.floor_area && lot.floor_area">
            <b>Surface plancher :</b> {{ lot.floor_area }} m²
          </div>
          <div v-if="lot && lot.unbuildable_area && lot.unbuildable_area">
            <b>Dont surface inconstructible :</b> {{ lot.unbuildable_area }} m²
          </div>
          <div v-if="lot && lot.exposures && lot.exposures.length">
            <b>Orientation :</b> {{ lot.exposures | exposuresLabel }}
          </div>
          <div v-if="lot && lot.nb_face && lot.nb_face !== null">
            <b>Nombre de face :</b> {{ lot.nb_face | nbfaceLabel }}
          </div>
          <div v-if="lot && lot.sales_mode && lot.sales_mode.length">
            <b>Mode de vente :</b> {{ lot.sales_mode | salesmodeLabel }}
          </div>
        </div>
      </div>

      <div
        v-if="lot.nature !== 'parking'"
        class="column is-padding-left-xsmall">
        <div class="is-margin-bottom-small">
          <span class="is-uppercase is-size-6 has-text-weight-medium">Annexe / Stationnement / Mobilier</span>
        </div>
        <div class="is-size-6">
          <template v-if="lot && lot.annex_list && lot.annex_list.length">
            <div
              v-for="(annex, index) in lot.annex_list"
              :key="'annex' + index">
              <b>{{ annex.annex_type | annexTypeLabel }} :</b>&nbsp;
              <span v-if="annex.surface">{{ annex.surface }} m²</span>&nbsp;
              <span v-if="annex.info">({{ annex.info }})</span>
            </div>
          </template>
          <template v-if="lot && lot.parkings && lot.parkings.length">
            <div
              v-for="(parking, index) in lot.parkings"
              :key="'parking' + index">
              <b>{{ parking.nature | lotTypeLabel }} :</b>&nbsp;
              <span
                v-for="(type, i ) in parking.parking_type"
                :key="'type' + i">{{ i > 0 ? ', ' : '' }}{{ type | lotSubtypeLabel }}</span>&nbsp;
              <span v-if="parking.info">({{ parking.info }})</span>&nbsp;
              <span
                v-for="(sale_mode, i ) in parking.sales_mode"
                :key="'sale_mode' + i">{{ i > 0 ? ', ' : '' }}{{ sale_mode | salesmodeLabel }}</span>
            </div>
          </template>
          <template v-if="lot && lot.furnitures && lot.furnitures.length">
            <div
              v-for="(furniture, index) in lot.furnitures"
              :key="'furniture' + index">
              <b>Meuble :</b>&nbsp;
              <span>{{ furniture.ref }}</span>&nbsp;
              <span v-if="furniture.info">({{ furniture.info }})</span>
            </div>
          </template>
          <div v-if="!lot.annex_list.length && !lot.parkings.length && !lot.furnitures.length">
            <i>Pas d'annexe renseignée</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'AdvLotCompact',
  mixins: [DefaultValues],
  props: {
    lot: {
      type: Object,
      default: () => {}
    },
    program: {
      type: Object,
      default: () => {}
    },
    displayButton: {
      type: Boolean,
      default: true
    },
    showSpecifications: {
      type: Boolean,
      default: true
    },
    rowMode: {
      type: Boolean,
      default: false
    },
    ForPreResa: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin'])
  },
  watch: {
    created () {
    }
  }
}
</script>
